module.exports = "/public/assets/defaultMemberImage.35eab2ece8d1f7956156fffe9f6491cc.png";


//////////////////
// WEBPACK FOOTER
// ./static-content/private/images/memberProfile/defaultMemberImage.png
// module id = 332
// module chunks = 0